import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Checkbox } from 'antd';

const CHECK_ICON_PATH =
  'M9.95997 16.71L5.96997 12.71L7.02997 11.65L9.95997 14.59L16.97 7.57999L18.03 8.63999L9.95997 16.71Z';

const CHECK_ICON_MASK =
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E` +
  `%3Cpath d='${CHECK_ICON_PATH}'/%3E%3C/svg%3E")`;

export const StyledKccCheckbox = styled(Checkbox)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled),
    .ant-checkbox:not(.ant-checkbox-disabled),
    .ant-checkbox-input:not(:disabled) {
      cursor: pointer;
    }

    .ant-checkbox-inner {
      position: relative;
      width: ${kcc.control.INTERACTIVE_SIZE}px;
      height: ${kcc.control.INTERACTIVE_SIZE}px;
      border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_500};
    }

    &.ant-checkbox-wrapper-disabled .ant-checkbox-inner {
      background-color: ${kcc.colors.WHITE};
    }

    .ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner {
      background-color: ${kcc.colors.BLACK} !important;
      border-color: ${kcc.colors.BLACK} !important;

      &::after {
        top: 50%;
        inset-inline-start: 50%;
        width: 8px;
        height: 2px;
        border: none;
        padding: 0;
        transform: translate(-50%, -50%);
        background-color: ${kcc.colors.WHITE};
      }
    }

    .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${kcc.colors.BLACK};
      border-color: ${kcc.colors.BLACK};

      &::after {
        top: 50%;
        inset-inline-start: 50%;
        width: ${kcc.control.INTERACTIVE_SIZE}px;
        height: ${kcc.control.INTERACTIVE_SIZE}px;
        border: none;
        transform: translate(-50%, -50%);
        background-color: ${kcc.colors.WHITE};
        mask-image: ${CHECK_ICON_MASK};
        mask-size: contain;
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }

    .ant-checkbox:not(.ant-checkbox-checked):not(.ant-checkbox-indeterminate):hover .ant-checkbox-inner {
      border-color: ${kcc.colors.GRAY_500};
    }

    .ant-checkbox:hover .ant-checkbox-inner::before,
    .ant-checkbox-wrapper:hover .ant-checkbox-inner::before {
      content: '';
      position: absolute;
      inset: -${kcc.lineWidth.BORDER}px;
      background-color: rgba(255, 255, 255, 0.16);
      pointer-events: none;
    }

    .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
      outline: 2px solid ${kcc.colors.BLUE[500]};
      outline-offset: 2px;
      border-color: ${kcc.colors.BLACK};
    }
  `}
`;
